import type { FC } from 'react';
import './DialogBase.css';
import classNames from 'classnames';
import { Button } from '../Button/Button';
import { Overlay } from '../Overlay/Overlay';
import { useStableCallback } from '../hooks/useStableCallback';
import { useManagedDomEventListeners } from '../utils/dom/ManagedDomEventListeners';
import { ESCAPE } from '../utils/keyboard/constants';
import type { DialogBaseProps } from './DialogBase.types';

export const DialogBase: FC<DialogBaseProps> = (props) => {
  const closeDialog = () => {
    if (props.closable !== false) {
      props.onClose();
    }
  };

  const handleKeyDown = useStableCallback((event: KeyboardEvent) => {
    if (event.which === ESCAPE) {
      closeDialog();
    }
  });

  useManagedDomEventListeners([window, 'keydown', handleKeyDown]);

  return (
    <Overlay onClose={closeDialog} capToWindowHeight={props.capToWindowHeight}>
      <div
        className={classNames(
          'dialog-base',
          props.capToWindowHeight && 'dialog-base--cap-to-window-height',
        )}
      >
        {props.closable !== false && (
          <div className='dialog-base__btn-cancel'>
            <Button
              variant='plain'
              icon='fa-xmark'
              onClick={closeDialog}
              type='button'
            />
          </div>
        )}
        <div className='dialog-base__header font-semibold'>
          {props.headerMsg}
        </div>
        {props.subHeaderMsg !== undefined && (
          <div className='dialog-base__text mt-2 font-normal'>
            {props.subHeaderMsg}
          </div>
        )}
        {props.children && (
          <div
            className={classNames(
              'dialog-base__body cross-browser-scrollbar mt-4',
              props.capToWindowHeight && 'flex-initial overflow-auto',
            )}
          >
            {props.children}
          </div>
        )}
        <div className='justify-between mt-8 flex'>
          <div className='flex gap-2'>{props.actionsLeft}</div>
          <div className='flex gap-2'>{props.actionsRight}</div>
        </div>
      </div>
    </Overlay>
  );
};
